module.exports = __webpack_public_path__ + "static/img/yz_01.562b43b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sy/yz_01.png
// module id = gU0n
// module chunks = 182